const subscribeToPrecisionApiResponse = (
    precisionApiResponse$,
    precisionStore,
) =>
    precisionApiResponse$
        .subscribe(precisionResponse => {
            const {
                cdns,
                refreshable,
                minRefreshInterval,
            } = precisionResponse;

            precisionStore.actions.updatePrecision({
                cdns,
                isRefreshable: refreshable,
                minRefreshWindowMs: minRefreshInterval,
            });
        });

export default subscribeToPrecisionApiResponse;
